<template>
  <div id="app">
    <v-app data-app>
      <luci-header
        :authenticated="authenticated"
        :logo="logo"
        :config="headerConfig"
        @settings-callback="headerSettingsCallback"
        @logo-callback="$router.push('/')"
        @login-callback="login"
      ></luci-header>

      <div class="luci-main">
        <template v-if="authenticated">
          <div class="luci-main-nav">
            <luci-nav :config="navConfig"></luci-nav>
          </div>

          <div class="luci-main-content">
            <luci-title :text="title" case="start-case"></luci-title>

            <div class="content">
              <router-view></router-view>
            </div>
          </div>
        </template>

        <template v-else> <!-- This is needed for the Callback component -->
          <div class="luci-main-content">
            <router-view></router-view>
          </div>
        </template>
      </div>

      <luci-footer :config="footerConfig"></luci-footer>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import variables from './helpers/variables'
import logo from './assets/images/pmc-logo.png'

export default {
  name: 'App',
  watch: {
    '$route' (to) {
      // update title for page
      if (to.matched.length > 0) this.title = this.getPageTitleFromRoute(to)
      else this.title = ''
    }
  },
  data () {
    return {
      logo: logo,
      navConfig: variables.navOptions.default,
      title: variables.pageTitle.default,
      footerConfig: {
        company: 'PM Connect Ltd'
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['authenticated', 'profile']),
    headerConfig: function () {
      return {
        applicationName: 'Games Manager',
        settings: {
          profile: {
            name: this.profile ? this.profile.name : null,
            username: this.profile ? this.profile.email : null,
            thumbnail: this.profile ? this.profile.picture : null
          },
          items: ['logout']
        }
      }
    }
  },
  created () {
    if (this.$route.name !== null) {
      this.title = this.getPageTitleFromRoute(this.$route)
    }
  },
  methods: {
    ...mapActions('auth', ['login', 'logout']),
    headerSettingsCallback (setting) {
      if (setting === 'logout') {
        this.logout().then(() => {
          if (this.$router.currentRoute.name !== 'Home') {
            this.$router.push({ name: 'Home' })
          }
        })
      }
    },
    getPageTitleFromRoute (route) {
      return route.matched[0].props.default.pageTitle
    }
  }
}
</script>

<style lang="scss">
  @import './assets/scss/base';

  #app {
    background-color: $white;
    color: $grey;

    // modal (NOTE: needs to be here)
    .v-overlay--active::before {
      opacity: .9;
    }
    .v-dialog {
      max-width: 1000px;
    }
  }
</style>
